import React, { Fragment, useState, useEffect, useContext } from "react";
import { Container, Button } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import JobSearch from "../../Components/Jobseeker/JobSearch";
import { JobSearchContext } from "../../JobSearch/JobSearchContext";
import { FaExclamationTriangle } from "react-icons/fa";

const JobSearchPage = () => {
  const { filters, updateFilters, clearFilters } = useContext(JobSearchContext);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (filters && !filters.verified_status) {
      updateFilters({ verified_status: "verified" });
    }
  }, [filters, updateFilters]);

  useEffect(() => {
    const stored = localStorage.getItem("jobSearchFilters");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const hasFilters =
          parsed.keyword ||
          (parsed.locations && parsed.locations.length > 0) ||
          (parsed.industry_type && parsed.industry_type.length > 0) ||
          (parsed.employment_type && parsed.employment_type.length > 0) ||
          (parsed.functional_area && parsed.functional_area.length > 0) ||
          (parsed.skills && parsed.skills.length > 0) ||
          (parsed.company && parsed.company.length > 0);

        if (hasFilters) {
          setShowWarning(true);
        }
      } catch (e) {
        console.error("Error parsing jobSearchFilters", e);
      }
    }
  }, []);

  const handleClearAll = () => {
    clearFilters();
    setShowWarning(false);
  };

  return (
    <Fragment>
      <Breadcrumbs title="Search Job" mainTitle="Search Job" />

      <Container fluid={true}>
        {showWarning && (
          <div
            className="mb-4 p-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 alert-last-search"
            style={{
              background: "linear-gradient(135deg, rgba(245, 158, 11, 0.06) 0%, rgba(245, 158, 11, 0.1) 100%)",
              border: "1px solid rgba(245, 158, 11, 0.2)",
              borderLeft: "4px solid #f59e0b",
              borderRadius: "12px",
              color: "#af5b00",
              boxShadow: "0 4px 12px rgba(245, 158, 11, 0.05)",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <FaExclamationTriangle size={18} className="text-warning flex-shrink-0" />
              <div>
                We are showing job results based on your <strong>last search</strong>. Clear the filters to see all latest jobs.
              </div>
            </div>
            <Button
              color="warning"
              size="sm"
              onClick={handleClearAll}
              style={{
                backgroundColor: "#f59e0b",
                borderColor: "#f59e0b",
                color: "#ffffff",
                fontWeight: "600",
                borderRadius: "8px",
                padding: "6px 16px",
                boxShadow: "0 2px 4px rgba(245, 158, 11, 0.2)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#d97706";
                e.target.style.borderColor = "#d97706";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#f59e0b";
                e.target.style.borderColor = "#f59e0b";
              }}
            >
              Clear Filters
            </Button>
          </div>
        )}
        <JobSearch />
      </Container>
    </Fragment>
  );
};

export default JobSearchPage;
